export class Log {
    constructor(
        public IDSampleLog: number,
        public CreatingIDUser: number,
        public CaptureLatitude: number,
        public CaptureLongitude: number,
        public UserLatitude: number,
        public UserLongitude: number,
        public IDSample: number,
        public Notes: string,
        public CaptureDate: any,
        public UpdateDate: any,
        public Received: number,
        public IDLab: number,
        public IsSync:Boolean,
        public ToStatus: string,
        public FromStatus: string,
    ) { };
}



// WEBPACK FOOTER //
// ./src/models/log.ts